import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import RegistrationForm from "./RegistrationForm";
import Ebadge from "./Ebadge";
import Login from "./Admin/Login";
import Module from "./Admin/OnsiteModule/Module";
import KioskPrint from "./Admin/OnsiteModule/KioskPrint";
import SecurityScan from "./Admin/OnsiteModule/SecurityScan";
import SearchPrint from "./Admin/OnsiteModule/SearchPrint";
import ProtectedRoutePage from "./Admin/ProtectedRoutePage.js";
import { useEffect } from "react";
import AuthRoute from "./AuthRoute.jsx";
import ForgotPassword from "./Admin/ForgotPassword.jsx";
import ResetPassword from "./Admin/ResetPassword.jsx";
import ErrorFormPage from "./Admin/ErrorFormPage.jsx";
import ErrorPage from "./Admin/ErrorPage.jsx";
import PartnersRegistrationForm from "./PartnersRegistrationForm.jsx";
function App() {
  useEffect(() => {
    const disableContextMenu = (e) => e.preventDefault();
    const disableCopy = (e) => e.preventDefault();
    const disableCut = (e) => e.preventDefault();

    document.addEventListener("contextmenu", disableContextMenu);
    document.addEventListener("copy", disableCopy);
    document.addEventListener("cut", disableCut);

    return () => {
      document.removeEventListener("contextmenu", disableContextMenu);
      document.removeEventListener("copy", disableCopy);
      document.removeEventListener("cut", disableCut);
    };
  }, []);

  return (
    <>
      <BrowserRouter basename="/symposium-visitor-registration">
        <Routes>
          <Route path="/" element={<RegistrationForm />} />
          <Route path="/partners" element={<PartnersRegistrationForm />} />
          <Route path="/ebadge/:id" element={<Ebadge />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route element={<AuthRoute roleRequired="admin" />}>
            <Route path="/onsite-module" element={<Module />} />
          </Route>
          <Route
            path="/search-print"
            element={<ProtectedRoutePage Component={SearchPrint} />}
          />
          <Route
            path="/kiosk-print"
            element={<ProtectedRoutePage Component={KioskPrint} />}
          />
          <Route
            path="/security-scan"
            element={<ProtectedRoutePage Component={SecurityScan} />}
          />

          {/* After event over  */}
          {/* <Route path="/" element={<ErrorFormPage />} />
          <Route path="/onsite-module" element={<Module />} /> */}
          {/* <Route path="/search-print" element={<ErrorPage />} />
          <Route path="/kiosk-print" element={<ErrorPage />} />
          <Route path="/security-scan" element={<ErrorPage />} /> */}
        </Routes>
      </BrowserRouter>
    </>
  );
}

export default App;
